import type { MessageKey } from "./ru"

export const thMessages = {
  "common.loading": "กำลังโหลด...",
  "common.error": "ข้อผิดพลาด",
  "common.back": "กลับ",
  "common.next": "ถัดไป",
  "common.search": "ค้นหา",
  "auth.loginErrorTitle": "เข้าสู่ระบบไม่สำเร็จ",
  "auth.openViaTelegram": "เปิดแอปผ่าน Telegram",
  "auth.telegramRequired": "ต้องเปิดแอปผ่าน Telegram",
  "auth.authorizationError": "ข้อผิดพลาดในการยืนยันสิทธิ์",
  "device.rotatePortrait": "หมุนอุปกรณ์เป็นแนวตั้ง",
  "country.brazil": "บราซิล",
  "country.vietnam": "เวียดนาม",
  "country.egypt": "อียิปต์",
  "country.india": "อินเดีย",
  "country.indonesia": "อินโดนีเซีย",
  "country.iran": "อิหร่าน",
  "country.spain": "สเปน",
  "country.italy": "อิตาลี",
  "country.kazakhstan": "คาซัคสถาน",
  "country.colombia": "โคลอมเบีย",
  "country.malaysia": "มาเลเซีย",
  "country.mexico": "เม็กซิโก",
  "country.nigeria": "ไนจีเรีย",
  "country.pakistan": "ปากีสถาน",
  "country.russia": "รัสเซีย",
  "country.usa": "สหรัฐอเมริกา",
  "country.turkey": "ตุรกี",
  "country.uzbekistan": "อุซเบกิสถาน",
  "country.ukraine": "ยูเครน",
  "country.philippines": "ฟิลิปปินส์",
  "countrySelection.chooseCountry": "เลือกประเทศ",
  "countrySelection.openAria": "เลือกประเทศ",
  "languageSelection.chooseLanguage": "เลือกภาษา",
  "commercial.direction.autotrade": "ตลาดรถ",
  "commercial.direction.insurance": "ประกันภัย",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "ช่วยเหลือฉุกเฉินบนถนน",
  "commercial.searchLabel": "ค้นหา BeepApp",
  "commercial.cityPlaceholder": "กรอกเมือง",
  "commercial.emptyTitle": "วันนี้ยังไม่มีข้อเสนอ",
  "commercial.emptyLine1": "ยังไม่มีพาร์ทเนอร์ BeepApp ที่เปิดใช้งานในเมืองของคุณ",
  "commercial.emptyLine2": "เรากำลังค้นหาและเชื่อมต่อพาร์ทเนอร์",
  "commercial.emptyLine3": "ข้อเสนอใหม่จะแสดงที่นี่โดยอัตโนมัติ",
  "commercial.helperLine1": "กรอกเมืองของคุณเพื่อดู",
  "commercial.helperLine2": "ข้อเสนอที่พร้อมใช้งาน",
  "commercial.partnerPrompt": "ต้องการเป็นพาร์ทเนอร์ BeepApp ไหม?",
  "commercial.apply": "สมัคร",
  "main.admin": "แอดมิน",
  "main.garage": "โรงรถ",
  "main.signalSent": "ส่งสัญญาณแล้ว",
  "main.partnerInviteUnavailable": "คำเชิญพาร์ทเนอร์ยังไม่พร้อมใช้งาน",
  "main.enterPlate": "กรอกป้ายทะเบียน",
  "main.searchError": "ค้นหาไม่สำเร็จ",
  "main.signalSendError": "ส่งสัญญาณไม่สำเร็จ",
  "main.shareCardPrefix": "การ์ดป้ายทะเบียน",
  "main.shareLinkError": "เตรียมลิงก์ไม่สำเร็จ",
  "main.searchByPlateAria": "ค้นหาด้วยป้ายทะเบียน",
  "main.russianPlateAria": "ป้ายทะเบียนรัสเซีย",
  "main.plateAria": "ป้ายทะเบียน",
  "main.findPlateAria": "ค้นหาป้ายทะเบียน",
  "main.loadingVehicle": "กำลังโหลดการ์ดรถ…",
  "main.leaveSignal": "ส่งสัญญาณ",
  "main.share": "แชร์",
  "signalSelection.chooseType": "เลือกประเภทสัญญาณ",
  "signalSelection.category.attention": "ส่วนตัว",
  "signalSelection.category.road": "ถนน",
  "signalSelection.category.urgent": "เร่งด่วน",
  "signalSelection.chooseSignal": "เลือกสัญญาณ",
  "signalSelection.suggestOwn": "เสนอแบบของคุณ",
  "signalConfirmation.title": "ยืนยันสัญญาณ",
  "signalConfirmation.plateHeading": "ตรวจสอบป้ายทะเบียน",
  "signalConfirmation.signalHeading": "ตรวจสอบสัญญาณที่เลือก",
  "signalConfirmation.replyTitle": "อนุญาตให้ตอบกลับใน Telegram",
  "signalConfirmation.replyBody": "เปิดตัวเลือกนี้เพื่อให้เจ้าของป้ายทะเบียนส่งข้อความ\nถึงคุณใน Telegram ได้ การตอบกลับทำได้เฉพาะเมื่อ\nคุณมี @username การตัดสินใจตอบกลับ\nขึ้นอยู่กับเจ้าของป้ายทะเบียน",
  "signalConfirmation.consentText": "ฉันยืนยันว่าสัญญาณนี้สะท้อน\nสถานการณ์จริง และไม่ใช่สแปม\nหรือรายงานเท็จ",
  "signalConfirmation.warning": "หลังส่งแล้วจะไม่สามารถ\nแก้ไขสัญญาณได้",
  "signalConfirmation.sending": "กำลังส่ง…",
  "signalConfirmation.send": "ส่ง",
  "partner.loadingAria": "กำลังโหลด",
  "partner.title": "โปรแกรมพาร์ทเนอร์",
  "partner.offerLine1": "รับ 30% จากการชำระเงินทั้งหมดของผู้ใช้ที่คุณเชิญอย่างต่อเนื่อง",
  "partner.offerLine2": "สำหรับผู้ใช้ที่คุณเชิญเข้ามาใน BeepApp",
  "partner.offerLine3": "ผ่านโปรแกรม Affiliate ของ Telegram",
  "partner.connectUnavailable": "จะเชื่อมต่อได้หลังจากตั้งค่าโปรแกรม Affiliate ของ Telegram แล้ว",
  "partner.connectTelegram": "เชื่อมต่อใน Telegram",
  "partner.qrAria": "QR โค้ดลิงก์พาร์ทเนอร์",
  "partner.download": "ดาวน์โหลด",
  "partner.promoHeading": "สร้างรหัสโปรโมส่วนตัว",
  "partner.promoHelperLine1": "รหัสโปรโมเปิดใช้งานสมาชิกเพิ่มอีก 1 ปี",
  "partner.promoHelperLine2": "และช่วยดึงดูดผู้ใช้",
  "partner.promoAria": "รหัสโปรโม",
  "partner.affiliateHeading": "ลิงก์ Affiliate ของคุณ",
  "partner.affiliateHelper": "บันทึกลิงก์เพื่อสร้าง QR โค้ดส่วนตัว",
  "partner.affiliateAria": "ลิงก์ Affiliate",
  "partner.qrNoteLine1": "สามารถติด QR โค้ดบนรถของคุณ",
  "partner.qrNoteLine2": "ในโซเชียลมีเดียและสื่อโฆษณาได้",
  "partner.save": "บันทึก",
  "partner.reset": "รีเซ็ต",
  "partner.resetConfirm": "รีเซ็ตลิงก์ Affiliate ที่บันทึกไว้หรือไม่? รหัสโปรโมจะยังเป็นของคุณ",
  "partner.promoFormatError": "รหัสโปรโมต้องมี 4 ถึง 15 ตัวอักษร",
  "partner.affiliateHostError": "อนุญาตเฉพาะลิงก์ t.me หรือ telegram.me",
  "partner.affiliatePathError": "ลิงก์ไม่มีเส้นทาง Telegram",
  "partner.affiliateFormatError": "ลิงก์ Affiliate ไม่ถูกต้อง",
  "partner.loadError": "โหลดไม่สำเร็จ",
  "partner.checkInputError": "ตรวจสอบข้อมูลที่กรอก",
  "garageActivation.promoInvalid": "รหัสโปรโมไม่ถูกต้อง",
  "garageActivation.plateOccupied": "ป้ายทะเบียนนี้เชื่อมโยงแล้ว",
  "garageActivation.activateError": "เปิดใช้งานโรงรถไม่สำเร็จ",
  "garageEntry.loadJournalError": "โหลดสมุดบันทึกไม่สำเร็จ",
  "garageEntry.loadStatusesError": "โหลดสถานะไม่สำเร็จ",
  "garageEntry.activationSuccess": "เปิดใช้งานโรงรถเรียบร้อยแล้ว",
  "garageEntry.plateAttached": "เชื่อมโยงป้ายทะเบียนแล้ว",
  "garageEntry.attachError": "เชื่อมโยงป้ายทะเบียนไม่สำเร็จ",
  "garageEntry.activationNote": "เปิดใช้งานโรงรถของคุณ",
  "garageSheet.activationTitle": "เปิดใช้งานโรงรถ",
  "garageSheet.plateHelper": "กรอกป้ายทะเบียนรถ",
  "garageSheet.promoHelper": "มีรหัสโปรโมหรือไม่?",
  "garageSheet.cleanBonusLine1": "หลังเปิดใช้งาน คุณมีเวลา 1 ชั่วโมง",
  "garageSheet.cleanBonusLine2": "สำหรับ “Clean Start” ฟรี",
  "garageSheet.activationFor": "เปิดใช้งานสำหรับ",
  "garageSheet.cost": "ค่าใช้จ่าย",
  "garageSheet.ownerConsentLine1": "ฉันยืนยันว่าเป็นเจ้าของ",
  "garageSheet.ownerConsentLine2": "รถที่มีป้ายทะเบียน",
  "garageSheet.ownerConsentLine3": "ตามที่ระบุ",
  "garageSheet.processing": "กำลังดำเนินการ...",
  "garageSheet.attach": "เชื่อมโยง",
  "garageSheet.pay": "ชำระเงิน",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "ปิดใช้งานโรงรถ",
  "garageLifecycle.cleanWarningLine1": "ประวัติป้ายทะเบียนจะถูกลบ",
  "garageLifecycle.cleanWarningLine2": "และไม่สามารถกู้คืนได้!",
  "garageLifecycle.deactivateWarningLine1": "หลังปิดใช้งาน การเข้าถึงฟังก์ชัน",
  "garageLifecycle.deactivateWarningLine2": "ที่ใช้งานอยู่ของโรงรถจะสิ้นสุดลง",
  "garageLifecycle.willBeDeleted": "จะถูกลบ",
  "garageLifecycle.cleanRemovedLine1": "• รายการทั้งหมดในสมุดบันทึก",
  "garageLifecycle.cleanRemovedLine2": "• ประวัติสัญญาณที่ได้รับ",
  "garageLifecycle.cleanRemovedLine3": "• ตัวนับสัญญาณสาธารณะ",
  "garageLifecycle.cleanRemovedLine4": "  บนการ์ดป้ายทะเบียน",
  "garageLifecycle.willRemain": "จะยังคงอยู่",
  "garageLifecycle.cleanPreservedLine1": "• การเชื่อมโยงป้ายทะเบียนกับโรงรถ",
  "garageLifecycle.cleanPreservedLine2": "• ระยะเวลาเปิดใช้งานที่เหลือ",
  "garageLifecycle.cleanPreservedLine3": "• สถานะป้ายทะเบียนที่เลือก",
  "garageLifecycle.cleanPreservedLine4": "• จำนวนการดูการ์ดป้ายทะเบียนทั้งหมด",
  "garageLifecycle.freeFirstHour": "ฟรีในชั่วโมงแรก",
  "garageLifecycle.willBecomeUnavailable": "จะไม่พร้อมใช้งาน",
  "garageLifecycle.deactivateRemovedLine1": "• สมุดบันทึก",
  "garageLifecycle.deactivateRemovedLine2": "• การเลือกและใช้สถานะป้ายทะเบียน",
  "garageLifecycle.deactivateRemovedLine3": "• คุณจะออกจาก AutoClan โดยอัตโนมัติ",
  "garageLifecycle.deactivateRemovedLine4": "• ตลาดรถ",
  "garageLifecycle.deactivateRemovedLine5": "• ประกันภัย",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• ช่วยเหลือฉุกเฉินบนถนน",
  "garageLifecycle.deactivateRemovedLine8": "• ป้ายทะเบียนจะถูกยกเลิกการเชื่อมโยงกับโรงรถ",
  "garageLifecycle.willRemainAvailable": "จะยังใช้งานได้",
  "garageLifecycle.deactivatePreservedLine1": "• ผู้ร่วมทาง",
  "garageLifecycle.deactivatePreservedLine2": "• ดิสแพตเชอร์",
  "garageLifecycle.deactivatePreservedLine3": "• การค้นหาและดูป้ายทะเบียน",
  "garageLifecycle.deactivatePreservedLine4": "  การ์ดรถสาธารณะ",
  "garageLifecycle.deactivatePreservedLine5": "• สามารถเปิดใช้งาน",
  "garageLifecycle.deactivatePreservedLine6": "  โรงรถอีกครั้งได้ทุกเมื่อ",
  "garageLifecycle.cleanConsentLine1": "ฉันยินยอมให้ลบ",
  "garageLifecycle.cleanConsentLine2": "ประวัติทั้งหมดของป้ายทะเบียนนี้",
  "garageLifecycle.cleanConsentLine3": "โดยไม่สามารถกู้คืนได้",
  "garageLifecycle.deactivateConsentLine1": "ฉันยืนยันการปิดใช้งานและ",
  "garageLifecycle.deactivateConsentLine2": "ยุติการเข้าถึงฟังก์ชันโรงรถ",
  "garageLifecycle.deactivateConsentLine3": "ที่ใช้งานอยู่ทั้งหมด",
  "garageLifecycle.clean": "ล้าง",
  "garageLifecycle.deactivate": "ปิดใช้งาน",
} satisfies Record<MessageKey, string>
